import classNames from 'classnames'
import React, { forwardRef, Ref } from 'react'

type Props = {
  children: React.ReactNode
  onClick?: (e?: any) => void
  disabled?: boolean
  type?: 'submit' | 'reset' | 'button' | undefined
  transparent?: boolean
  className?: string
}

const GhostButton = (props: Props, ref: Ref<HTMLButtonElement>): JSX.Element => {
  const { children, onClick, disabled, type, transparent, className } = props
  return (
    <button
      ref={ref}
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={classNames(
        `py-2 px-3 rounded text-white font-Spartan font-bold h-8 flex flex-row items-center justify-center text-xs text-primary-persian-blue ${className}`,
        {
          'bg-transparent ': transparent,
          'bg-palatinate-blue/10': !transparent,
          'opacity-50': disabled,
        },
      )}>
      {children}
    </button>
  )
}

export default forwardRef(GhostButton)
